import type { DefineComponent, ExtractPropTypes } from "vue";
import { appLauncherProps } from "@jfrog/ui-platform-common/components/AppLauncher/appLauncherProps";
import AppLauncherComponent from "@jfrog/ui-platform-common/components/AppLauncher/index.vue";

// Resolved (internal) prop shape — handy for typing computed values fed into the component.
export type AppLauncherProps = ExtractPropTypes<typeof appLauncherProps>;

// `@jfrog/ui-platform-common` ships raw, un-typed `.vue` source (no .d.ts), so the
// bare module resolves to a generic `DefineComponent`. We re-cast it with the prop
// *options* object the package exports as plain `.ts`, so Vue derives required vs
// optional (defaulted) props correctly and consumers get full inference.
export const AppLauncher = AppLauncherComponent as unknown as DefineComponent<
  typeof appLauncherProps
>;

export type {
  SiteDTO as AppLauncherSiteDTO,
  SubscriptionDTO as AppLauncherSubscriptionDTO,
  ContactDTO as AppLauncherContactDTO,
  AppLauncherDataResponse,
  HelpLinkDTO as AppLauncherHelpLinkDTO,
} from "@jfrog/ui-platform-common/components/AppLauncher/types";
